angular
    .module('empower.memberBenefit')
    .service('memberBenefitService', ['$rootScope', '$filter', '$q', 'httpService',
        function ($rootScope, $filter, $q, httpService) {
            return {
                getResources: getResources,
                downloadResource: downloadResource,
            };

            function getResources() {
                var def = $q.defer(),
                    APITarget = "api/memberbenefit/getlist";

                httpService.httpRequest(APITarget).then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            }

            function downloadResource(filePath, displayName) {
                APITarget = "api/memberbenefit/downloadfile";
                Values = JSON.stringify({
                    FilePath: filePath,
                });
                var options = {
                    responseType: 'arraybuffer'
                };
                httpService.httpRequest(APITarget, Values, 'GET', options).then(function (data) {
                    if (angular.isDefined(data.File)) {
                        var contentType = "";
                        var ext = filePath.split('.').pop();
                        switch (ext) {
                            case "doc":
                                contentType = "application/msword";
                                break;
                            case "docx":
                                contentType = "application/vnd.openxmlformats-officedocument.wordprocessingml.template";
                                break;
                            case "pdf":
                                contentType = "application/pdf";
                                break;
                            case "xls":
                                contentType = "application/vnd.ms-excel";
                                break;
                            case "xlsx":
                                contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                                break;
                            default:
                                contentType = "text/csv";
                                break;

                        }
                        var file = new Blob([data.File], {
                            type: contentType
                        });

                        saveAs(file, displayName + '.' + ext);
                        return true;
                    } else
                        return false;
                });

            }
        }
    ]);